import * as React from 'react'
import { FieldState, pageSizeOptions } from '@user/components/xGrid'
import { useRows } from './hooks/useRows'
import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'
import { useImportColumnsSettings } from './columns/useImportColumnsSettings'
import { useSortModel } from './hooks/useSortModel'
import { WWMXGrid } from '@user/components/xGrid/WWMXGrid'
import { useLongPolling } from './hooks/useLongPolling'

export function ImportDataGrid() {
  const { lockedImportColumns, orderedColumns, columnVisibility } =
    useImportColumnsSettings()

  const { count, densityMode, pageSize, page, loading } = useData()

  const { sortModel } = useSortModel({ columns: orderedColumns })

  const {
    onStateChange,
    onSaveColumnState,
    onSortModelChange,
    onPaginationModelChange,
    onColumnWidthChange,
  } = useHandlers({
    densityMode,
    columns: orderedColumns,
  })
  const rows = useRows()

  useLongPolling()

  return (
    <WWMXGrid
      columns={orderedColumns}
      density={densityMode}
      isDensityEnable
      onColumnWidthChange={(e) =>
        onColumnWidthChange(e?.colDef, orderedColumns, columnVisibility)
      }
      columnsSelectorProps={{
        saveCallback: (e: FieldState[]) => onSaveColumnState(e, orderedColumns),
        lockedColumns: lockedImportColumns,
        defaultColumns: ['name', 'status', 'description'],
        defaultVisibility: {
          name: true,
          status: true,
          createdBy: false,
          description: true,
        },
      }}
      rows={rows}
      onStateChange={onStateChange}
      columnVisibilityModel={columnVisibility}
      width="100%"
      rowCount={count}
      throttleRowsMs={2000}
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      onPaginationModelChange={onPaginationModelChange}
      paginationModel={{ page: page - 1, pageSize: pageSize }}
      loading={loading}
      localeText={{
        noRowsLabel: 'No imports',
      }}
      pagination={true}
      pageSizeOptions={pageSizeOptions}
    />
  )
}
